import { useMutation } from '@tanstack/react-query';
import api from '@api/http/api';

export function useChangeUsernameMutation() {
  return useMutation<{ success: boolean }, {}, { username: string }>({
    mutationFn: (values) => api.post('/auth/username', values),
  });
}